/**
 * Standardized "you can't edit this" reminder for a popup or panel that has
 * editable controls. Every such surface shows the same strip so the message
 * is recognizable wherever it appears, rather than each one wording its own.
 *
 * Pair with disabling/guarding the controls themselves (each surface does its
 * own, via `useSession().canEdit` and, for non-form elements that can't just
 * take a `disabled` prop, `notifyViewOnlyBlocked()` from api/client) — this is
 * the explanation, not the enforcement.
 */

export function ViewOnlyBanner({ compact = false }: { compact?: boolean }) {
  return (
    <div
      style={{
        display: 'flex', alignItems: 'center', gap: 6,
        padding: compact ? '5px 10px' : '7px 14px',
        background: '#fef3c7', color: '#92400e', fontSize: compact ? 11 : 12, fontWeight: 700,
        borderBottom: '1px solid #fde68a', flexShrink: 0,
      }}
    >
      <span aria-hidden="true">🔒</span>
      View only — switch to Edit in the header to make changes.
    </div>
  );
}
